<template>
    <div>
        <div class="text-xs-center">
            <v-layout row wrap>
                <v-flex xs12 sm12 md6>
                    <v-select
                        @change="getItems()"
                        class="pt-0 mt-3 pr-1" color="teal"
                        v-model="productCategory" ref="productCategory"
                        item-text="name" dense small
                        item-value="id"
                        :items="productCategories"
                        label="Select Product Category"
                    ></v-select>
                </v-flex>

                <v-flex xs10 sm10 md5>
                    <v-text-field
                        v-model="search" ref="search" class="pt-0 mt-3 pl-1"
                        label="Search Item (name, category, type)..."
                        required dense
                    ></v-text-field>
                </v-flex>
                <v-flex xs2 sm2 md1>
                    <v-btn fab small color="teal" @click="getSearchedItems()">
                        <i class="fas fa-search white--text"></i>
                    </v-btn>
                </v-flex>
            </v-layout>

            <!-- Indicateur visuel de la catégorie sélectionnée -->
            <v-layout row wrap class="mt-3 mb-2">
                <v-flex xs12>
                    <v-chip
                        v-if="selectedCategoryName && productCategory"
                        color="primary"
                        text-color="white"
                        class="category-indicator"
                    >
                        <v-icon left small>filter_list</v-icon>
                        <strong>{{ selectedCategoryName }}</strong>
                        <v-icon right small @click.stop="clearCategoryFilter">close</v-icon>
                    </v-chip>
                </v-flex>
            </v-layout>
        </div>

        <v-layout row wrap class="products-container">
            <v-flex xs12 class="mt-4 pt-2 text-xs-center" v-if="mostBoughtItems.length == 0">
                <div v-if="search.length > 0">
                    <h3>No Products Found For This Search <b class="red--text">"{{ search }}"</b></h3>
                    <p class="grey--text mt-2">Try searching with different keywords or browse other categories.</p>
                </div>
                <div v-else>
                    <v-icon size="64" color="grey lighten-1" class="mb-3">shopping_basket</v-icon>
                    <h3 class="mb-2">No Products Available in <b class="primary--text">{{ selectedCategoryName }}</b></h3>
                    <p class="grey--text">Please select a different category from the dropdown above to explore our products.</p>
                    <v-btn color="primary" outlined class="mt-3" @click="$refs.productCategory.focus()">
                        <v-icon left>filter_list</v-icon>
                        Change Category
                    </v-btn>
                </div>
            </v-flex>

            <!-- Structure avec image étendue vers le haut -->
            <v-flex xs12 sm6 md4 lg3 v-for="item in mostBoughtItems" :key="item.id"
                    class="product-item" :class="{ 'business-product': isBusinessCategory }">
                <v-hover>
                    <v-card color="white" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`"
                            @click="handleProductClick(item)"
                            style="border-radius: 10px; height: 100%; margin: 12px; overflow: hidden;">
                        <v-container fluid class="pa-0">
                            <v-layout column class="ma-0 pa-0">
                                <!-- Section média ÉTIRÉE VERS LE HAUT - HAUTEUR AUGMENTÉE -->
                                <v-flex class="pa-0 ma-0 image-section">
                                    <div class="media-container" style="position: relative; width: 100%; height: 320px; background: #f8f8f8; overflow: hidden;">

                                        <!-- Affichage vidéo -->
                                        <video
                                            v-if="isVideo(item.get_image)"
                                            :src="item.get_image"
                                            style="width: 100%; height: 100%; object-fit: cover;"
                                            controls
                                            preload="metadata"
                                            @mouseenter="playVideo"
                                            @mouseleave="pauseVideo"
                                        >
                                            Your browser does not support the video tag.
                                        </video>

                                        <!-- Affichage image - HAUTEUR CONSIDÉRABLEMENT AUGMENTÉE -->
                                        <v-img
                                            v-else
                                            :src="item.get_image"
                                            :lazy-src="item.get_image"
                                            height="320px"
                                            width="100%"
                                            style="transition: transform 0.4s ease;"
                                            :style="hover ? 'transform: scale(1.08)' : ''"
                                            cover
                                        >
                                            <template v-slot:placeholder>
                                                <v-layout fill-height align-center justify-center ma-0>
                                                    <v-progress-circular indeterminate color="teal"></v-progress-circular>
                                                </v-layout>
                                            </template>
                                        </v-img>

                                        <!-- Overlay amélioré -->
                                        <div
                                            v-if="!isVideo(item.get_image) && hover"
                                            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.4); display: flex; align-items: center; justify-content: center; transition: all 0.3s; opacity: 1;"
                                        >
                                            <v-icon size="48" color="white" style="text-shadow: 0 2px 4px rgba(0,0,0,0.5);">zoom_in</v-icon>
                                        </div>
                                    </div>
                                </v-flex>

                                <!-- Section informations - EXACTEMENT comme dans votre version originale -->
                                <v-flex class="ma-0 pa-2 text-xs-left info-section" style="width: 100%;">
                                    <div class="ml-1">
                                        <div class="title ma-0 pa-0 text-xs-left"><u>{{item.name | truncate(23, '...') }}</u></div>
                                        <div>
                                            <v-layout row wrap class="ma-0 pa-0">
                                                <v-flex xs12 text-xs-left class="ma-0 pt-2 pb-0 px-0">
                                                    <span class="dark--text font-weight-bold">Description:</span> {{ item.description | truncate(55, '...')  }}
                                                </v-flex>
                                                <v-flex xs8 text-xs-left class="ma-0 pa-0">
                                                    <span class="dark--text font-weight-bold">Cost:</span><span> {{item.price}} FCFA</span>
                                                </v-flex>
                                                <v-flex xs4 text-xs-right class="ma-0 pa-0">
                                                    <span class="dark--text font-weight-bold">Qty:</span><span> {{item.quantity}}</span>
                                                </v-flex>
                                                <v-flex xs6 text-xs-left class="ma-0 pa-0">
                                                    <span class="dark--text font-weight-bold">In-Stock:</span><span> {{item.quantity}}</span>
                                                </v-flex>
                                                <v-flex xs6 text-xs-right class="ma-0 pa-0">
                                                    <span class="dark--text font-weight-bold">Type:</span><span> {{item.category}}</span>
                                                </v-flex>
                                            </v-layout>
                                        </div>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-hover>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        data() {
            return {
                search: '',
                productCategory: '',
                productCategories: [],
                mostBoughtItems: [],
                imageDisplayMode: 'cover',
                // ID fixe pour la catégorie business
                BUSINESS_CATEGORY_ID: 5
            }
        },

        mounted(){
            document.title = "PettyCash | Market Place"

            // Vérifier si un paramètre de catégorie existe dans l'URL
            const urlParams = new URLSearchParams(window.location.search)
            const categoryParam = urlParams.get('category')

            this.getProductCategories().then(() => {
                // Si un paramètre de catégorie existe, l'utiliser
                if (categoryParam) {
                    this.productCategory = parseInt(categoryParam)
                    // Forcer le focus visuel sur le select pour montrer la sélection
                    this.$nextTick(() => {
                        if (this.$refs.productCategory) {
                            // Animation visuelle pour attirer l'attention
                            this.$refs.productCategory.$el.classList.add('category-selected-animation')
                            setTimeout(() => {
                                this.$refs.productCategory.$el.classList.remove('category-selected-animation')
                            }, 1000)
                        }
                    })
                }
                this.getItems()
            })

            this.$store.commit('setCloseURL', "/market_place")
        },

        computed: {
            // Récupérer le nom de la catégorie sélectionnée
            selectedCategoryName() {
                const category = this.productCategories.find(cat => cat.id == this.productCategory)
                return category ? category.name : ''
            },

            // Vérifier si la catégorie actuelle est business
            isBusinessCategory() {
                return parseInt(this.productCategory) === this.BUSINESS_CATEGORY_ID;
            }
        },

        methods:{
            // Nouvelle méthode pour gérer le clic sur un produit
            handleProductClick(item) {
                // Vérifier si la catégorie actuelle est business (ID = 5)
                if (this.isBusinessCategory) {
                    // Rediriger vers la page de création de compte business
                    this.$router.push('/create_business_account4');
                } else {
                    // Rediriger vers la page détaillée du produit comme avant
                    this.$router.push('/market_place/items/' + item.id);
                }
            },

            isVideo(url) {
                if (!url) return false
                const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.wmv', '.flv', '.mkv']
                const lowerUrl = url.toLowerCase()
                return videoExtensions.some(ext => lowerUrl.includes(ext))
            },

            playVideo(event) {
                if (event.target.tagName === 'VIDEO') {
                    event.target.play().catch(() => {
                        // Ignorer l'erreur si autoplay est bloqué
                    })
                }
            },

            pauseVideo(event) {
                if (event.target.tagName === 'VIDEO') {
                    event.target.pause()
                }
            },

            clearCategoryFilter() {
                // Réinitialiser à la première catégorie
                if (this.productCategories.length > 0) {
                    this.productCategory = this.productCategories[0].id
                    // Supprimer le paramètre de l'URL
                    const url = new URL(window.location)
                    url.searchParams.delete('category')
                    window.history.pushState({}, '', url)
                    this.getItems()
                }
            },

            async getProductCategories(){
                this.$store.commit('setIsLoading', true)

                return await axios
                    .get('/api/v1/market_place/get/products/categories/')
                    .then(response => {
                        this.productCategories = response.data

                        // Ne pas définir productCategory ici automatiquement si vide
                        if (!this.productCategory) {
                            this.productCategory = response.data[0]["id"]
                        }
                        return response.data
                    })
                    .catch(error => {
                        if (error.response){
                            this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
                            this.$store.commit('setSnackBarColor', "red darken-4")
                            this.$store.commit('activateSnackBar', true)
                        }else{
                            this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
                            this.$store.commit('setSnackBarColor', "red darken-4")
                            this.$store.commit('activateSnackBar', true)
                        }
                    })
                    .finally(() => {
                        this.$store.commit('setIsLoading', false)
                    })
            },

            async getItems(){
                this.$store.commit('setIsLoading', true)

                const type = this.$route.params.type
                await axios
                    .get('/api/v1/market_place/get/products/'+this.productCategory+'/'+type+'/info/')
                    .then(response => {
                        this.mostBoughtItems = response.data
                    })
                    .catch(error => {
                        if (error.response){
                            this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
                            this.$store.commit('setSnackBarColor', "red darken-4")
                            this.$store.commit('activateSnackBar', true)
                        }else{
                            this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
                            this.$store.commit('setSnackBarColor', "red darken-4")
                            this.$store.commit('activateSnackBar', true)
                        }
                    })
                this.$store.commit('setIsLoading', false)
            },

            async getSearchedItems(){
                if(this.search == ""){
                    this.$store.commit('setSnackBarMessage', "Please input search item")
                    this.$store.commit('setSnackBarColor', "red darken-4")
                    this.$store.commit('activateSnackBar', true)
                    this.$refs.search.focus()
                }
                else{
                    this.$store.commit('setIsLoading', true)
                    const type = this.$route.params.type
                    await axios
                        .get('/api/v1/market_place/get/products/'+this.productCategory+'/'+type+'/'+this.search+'/info/')
                        .then(response => {
                            this.mostBoughtItems = response.data
                        })
                        .catch(error => {
                            if (error.response){
                                this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
                                this.$store.commit('setSnackBarColor', "red darken-4")
                                this.$store.commit('activateSnackBar', true)
                            }else{
                                this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
                                this.$store.commit('setSnackBarColor', "red darken-4")
                                this.$store.commit('activateSnackBar', true)
                            }
                        })
                    this.$store.commit('setIsLoading', false)
                }
            },
        },

        watch: {
            '$route': function(to, from) {
                // Vérifier si un paramètre de catégorie existe dans la nouvelle route
                const urlParams = new URLSearchParams(window.location.search)
                const categoryParam = urlParams.get('category')

                if (categoryParam) {
                    this.productCategory = parseInt(categoryParam)
                }

                this.getItems()
            }
        },
    }
</script>
<style scoped>
.theme--light.v-messages {
    display: none;
}

.media-container video::-webkit-media-controls {
    opacity: 0.7;
}

.media-container video:hover::-webkit-media-controls {
    opacity: 1;
}

/* Animation pour la sélection de catégorie */
@keyframes categoryPulse {
    0%, 100% {
        box-shadow: 0 0 0 0 rgba(0, 150, 136, 0.7);
    }
    50% {
        box-shadow: 0 0 0 10px rgba(0, 150, 136, 0);
    }
}

.category-selected-animation {
    animation: categoryPulse 1s ease-in-out;
}

/* Style pour le chip d'indicateur de catégorie */
.category-indicator {
    font-size: 16px !important;
    padding: 8px 16px !important;
    animation: slideInDown 0.5s ease-out;
}

@keyframes slideInDown {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.category-indicator .v-icon:last-child {
    cursor: pointer;
    transition: transform 0.2s ease;
}

.category-indicator .v-icon:last-child:hover {
    transform: scale(1.2) rotate(90deg);
}

/* Styles pour l'espacement */
.products-container {
    margin: 0 -8px;
}

.product-item {
    padding: 4px;
}

.v-card {
    transition: all 0.3s ease;
    width: 100%;
    display: flex;
    flex-direction: column;
    cursor: pointer;
}

.v-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 16px -6px rgba(0, 0, 0, 0.2) !important;
}

/* Assurer que toutes les cartes aient la même hauteur */
.v-flex.xs12.sm6.md4.lg3 {
    display: flex;
}

/* Section image étendue VERS LE HAUT */
.image-section {
    flex: 0 0 auto;
    width: 100%;
}

/* Section informations */
.info-section {
    flex: 1 0 auto;
    background: white;
}

/* Garantir que le conteneur média utilise toute la largeur */
.media-container {
    width: 100% !important;
}

/* Forcer l'image à utiliser toute la largeur disponible */
.v-image {
    width: 100% !important;
    min-width: 100% !important;
}

/* Ajustements responsive avec hauteurs adaptatives - AUGMENTÉES */
@media (max-width: 600px) {
    .product-item {
        padding: 6px;
    }

    .v-card {
        margin: 8px !important;
    }

    .media-container {
        height: 280px !important;
    }
}

@media (min-width: 960px) {
    .product-item {
        padding: 8px;
    }

    .media-container {
        height: 320px !important;
    }
}

@media (min-width: 1264px) {
    .media-container {
        height: 340px !important;
    }
}

/* Animation subtile au survol de l'image */
.v-card:hover .v-image {
    filter: brightness(1.05);
}

/* Style optionnel pour les produits business */
.product-item.business-product .v-card {
    border: 2px solid #ff9800 !important;
}

.product-item.business-product .v-card:hover {
    border-color: #f57c00 !important;
    box-shadow: 0 8px 25px -5px rgba(255, 152, 0, 0.3) !important;
}
</style>